"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* SoulModule
*/
var SoulModule =
/*#__PURE__*/
function () {
  /*
  * SoulModule constructor
  * @param {Object} params
  * @param {string} params.api ref to api for making request
  * @param {string} params.apiKey
  */
  function SoulModule(_ref) {
    var api = _ref.api,
        apiKey = _ref.apiKey,
        storage = _ref.storage,
        eventEmitter = _ref.eventEmitter;

    _classCallCheck(this, SoulModule);

    this.apiKey = apiKey;
    this.api = api;
    this.storage = storage;
    this.eventEmitter = eventEmitter; // this.login = mandatory([], this.login)
  }
  /*
  * helper method
  * @param {Object} validationHash hash that look like {validationRule: [propertiesForApllying]}
  */


  _createClass(SoulModule, [{
    key: "_addValidationAndBind",
    value: function _addValidationAndBind(validationHash) {
      var _this = this;

      Object.keys(validationHash).forEach(function (methodName) {
        console.log(methodName);

        if (typeof _this[methodName] !== 'function') {
          var className = _this.constructor && _this.constructor.name;
          throw new Error("Module ".concat(className, " don't have a method ").concat(methodName));
        } // TODO apply validation rules

      });
    }
  }]);

  return SoulModule;
}();

module.exports = SoulModule;